import { render, staticRenderFns } from "./QuestionSlider.vue?vue&type=template&id=543c21ff&scoped=true"
import script from "./QuestionSlider.vue?vue&type=script&lang=js"
export * from "./QuestionSlider.vue?vue&type=script&lang=js"
import style0 from "./QuestionSlider.vue?vue&type=style&index=0&id=543c21ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543c21ff",
  null
  
)

export default component.exports